const DEFAULT_TEMPLATE = "AWB - {{AWBs}}\n\narrange for {{status}} for the above highlighted shipments";

export function interpolateTemplate(template, ctx) {
  return (template || "").replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    const v = ctx[key];
    return v == null ? "" : String(v);
  });
}

export function buildWaMessage(shipments, { statusLabel, template } = {}) {
  const list = shipments || [];
  const awbs = list.map((s) => s.tracking_number).filter(Boolean).join(",");
  const orderIds = list.map((s) => s.order_id).filter(Boolean).join(",");
  const couriers = [...new Set(list.map((s) => s.courier_partner).filter(Boolean))].join(", ");
  const ctx = {
    AWBs: awbs,
    awbs,
    order_ids: orderIds,
    courier_name: couriers,
    status: statusLabel || "priority delivery",
    count: list.length,
  };
  const tpl = template && template.trim() ? template : DEFAULT_TEMPLATE;
  return interpolateTemplate(tpl, ctx);
}

export function buildWhatsappUrl(shipments, opts) {
  const msg = buildWaMessage(shipments, opts);
  const list = shipments || [];
  const phone = list.length === 1 ? String(list[0]?.phone || "").replace(/\D/g, "") : "";
  return phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`
    : `https://wa.me/?text=${encodeURIComponent(msg)}`;
}

export function groupByCourier(shipments) {
  const map = {};
  for (const s of shipments) {
    const key = s.courier_partner || "Unknown";
    (map[key] = map[key] || []).push(s);
  }
  return Object.entries(map)
    .map(([courier, items]) => ({ courier, items }))
    .sort((a, b) => b.items.length - a.items.length);
}
